import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  margin-left: ", "px;\n  position: relative;\n\n  &::before {\n    border-left: 1px solid ", ";\n    bottom: 8px;\n    content: '';\n    left: ", "px;\n    position: absolute;\n    top: 0;\n    width: 1px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { color, size } from '@scp/ui-shared/theme/variables';
import { RADIO_BUTTON_SIZE } from '@scp/ui-shared/components/switches/RadioButton';
import { CHECKBOX_SIZE } from '@scp/ui-shared/components/switches/Checkbox';
var CHILD_GROUP_LEFT_OFFSET = 40;

var getLeftPosition = function getLeftPosition(props) {
  var buttonSize = props.$isCheckbox ? CHECKBOX_SIZE : RADIO_BUTTON_SIZE;
  var leftOffset = props.$leftOffset || CHILD_GROUP_LEFT_OFFSET;
  return buttonSize / 2 + size.gutter / 2 - leftOffset;
};

export var ChildGroupWrapper = styled.div(_templateObject(), CHILD_GROUP_LEFT_OFFSET, color.borderInput, function (props) {
  return getLeftPosition(props);
});